<template>
  <v-dialog
      :value="detailDialog"
      @click:outside="closeDetailDialog"
      max-width="600px"
      transition="dialog-transition"
  >
    <v-card v-if="item" class="rounded-lg white">
      <v-card-title class="secondary back--text">
        {{ item.customer_name || item.customer_phone || 'کاربر' }}
        <v-spacer></v-spacer>
        <span class="text-caption">{{ statusLabel }}</span>
      </v-card-title>
      <v-card-text class="py-3">
        <p>{{ item.text }}</p>

        <v-img
            v-if="item.comment_file"
            :src="img_source(item.comment_file)"
            max-height="260"
            max-width="260"
            class="rounded-lg mb-3"
            contain
        ></v-img>

        <div v-if="item.replies && item.replies.length" class="mt-3">
          <strong>پاسخ‌ها:</strong>
          <p v-for="r in item.replies" :key="r.id">{{ r.text }}</p>
        </div>

        <v-textarea
            v-model="replyText"
            label="پاسخ ادمین"
            class="mt-4"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            @click="moderate('reject')"
            color="error white--text"
            class="rounded-lg"
            :disabled="item.status == 'rejected'"
        >رد کردن</v-btn>
        <v-btn
            depressed
            @click="moderate('approve')"
            color="success white--text"
            class="rounded-lg"
            :disabled="item.status == 'approved'"
        >تایید</v-btn>
        <v-btn
            depressed
            @click="sendReply"
            color="primary white--text"
            class="rounded-lg"
            :disabled="!replyText"
        >ارسال پاسخ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommentModerationDialog",
  props: {
    item: { required: true },
    detailDialog: {},
  },
  data() {
    return { replyText: "" };
  },
  computed: {
    statusLabel() {
      if (!this.item) return "";
      return { pending: "در انتظار تایید", approved: "تایید شده", rejected: "رد شده" }[this.item.status] || this.item.status;
    },
  },
  watch: {
    item() {
      this.replyText = "";
    },
  },
  methods: {
    moderate(action) {
      this.request({
        url: this.endpoint(`shop/adminComment/${this.item.id}/moderate`),
        method: "patch",
        data: { action },
        success: () => {
          this.$emit("statusChanged");
          this.closeDetailDialog();
        },
      });
    },
    sendReply() {
      this.request({
        url: this.endpoint(`shop/adminComment/${this.item.id}/reply`),
        method: "post",
        data: { text: this.replyText },
        success: () => {
          this.$emit("statusChanged");
          this.closeDetailDialog();
        },
      });
    },
    closeDetailDialog() {
      this.$emit("click:outside");
      this.$emit("update:detailDialog", false);
    },
  },
};
</script>
